import Axios from "axios";
import axios from "axios";

export const userServiceAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_USER_SERVICE_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("AccessToken"),
  },
});

userServiceAxiosInstance.interceptors.request.use(
  async (config) => {
    const token = await localStorage.getItem("AccessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
